"use client";

import { resumeUrlFor } from "@components/order/utils/resume-destination";
import React, { useState, useEffect } from "react";
import { useRouter } from "src/i18n/navigation";
import { Box, Button, Modal, Typography } from "@mui/material";
import nookies from "nookies";
import { useAppTranslate } from "src/hooks/useAppTranslate";
import { userApi } from "src/services/api";
import { GetOrderDto, GetUserDto } from "src/services/generated-api";
import { getGuestTokenCookies } from "src/services/api";


const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const UnfinishedModal = ({ oldOrder }: { oldOrder: GetOrderDto | null }) => {
  const [showContinueOrderModal, setShowContinueOrderModal] = useState(false);
  const [user, setUser] = useState<GetUserDto | null>(null);

  const router = useRouter();
  const t = useAppTranslate();

  useEffect(() => {
    if (!nookies.get(null).bearerToken) return;
    userApi.userControllerGetMe().then(res => setUser(res.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const guestToken = getGuestTokenCookies();

    if (oldOrder) {
      const oldUserId = oldOrder?.user as { id?: string } | undefined;

      if (user?.id === oldUserId?.id || guestToken) {
        setShowContinueOrderModal(true);
      }
    }
  }, [oldOrder, user]);

  const handleContinueToCheckout = () => {
    const guestToken = getGuestTokenCookies();

    // The rule (and why it exists) lives in resumeStepFor -- shared with the
    // resume-old-order button so the two cannot drift apart.
    router.push(
      resumeUrlFor(
        window.location.origin,
        oldOrder?.id,
        {
          shippingEmail: oldOrder?.shippingEmail,
          paymentOption: oldOrder?.paymentOption,
        },
        guestToken,
      ),
    );
  };

  const handleStartNewOrder = () => {
    // Logic to start a new order
    // For example, redirecting to the order creation page
    router.push("/");
    // Reload the page to reset the state
    window.location.reload();
  };

  return (
    <Modal
      open={showContinueOrderModal}
      onClose={() => setShowContinueOrderModal(false)}
      aria-labelledby="continue-order-modal-title"
      aria-describedby="continue-order-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography
          id="continue-order-modal-title"
          variant="h6"
          component="h2"
          sx={{ margin: 2 }}
        >
          {t("orderModal.continueOrder")}
        </Typography>
        <Typography id="continue-order-modal-description" sx={{ mb: 2 }}>
          {t("orderModal.continueOrderDescription")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            flexDirection: "column",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowContinueOrderModal(false)}
            sx={{ m: 1 }}
          >
            {t("orderModal.continue")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleStartNewOrder()}
            sx={{ m: 1 }}
          >
            {t("orderModal.startNew")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ color: "primary.contrastText", m: 1 }}
            onClick={handleContinueToCheckout}
          >
            {t("orderModal.continueToCheckout")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UnfinishedModal;
